import { State } from './types';
import {
    Actions,
    RESET_CART,
    SET_CART,
    SET_RECOVERED_CART,
    SET_CART_LOADING,
    UPDATE_CART_PARTIAL,
    RESERVE_CART_START,
    RESERVE_CART_SUCCESS,
    RESERVE_CART_FAILURE,
} from './actions';

export const NAMESPACE = 'cart';

const initialState: State = {
    cart: null,
    recoveredCart: null,
    isLoading: false,
    reservationError: null,
};

export const reducer = (state: State = initialState, action: Actions) => {
    switch (action.type) {
        case RESET_CART:
            return {
                ...state,
                cart: null,
                recoveredCart: null,
                isLoading: false,
                reservationError: null,
            };
        case SET_CART:
            return { ...state, cart: action.payload.cart, isLoading: false };
        case SET_RECOVERED_CART:
            return { ...state, recoveredCart: action.payload.recoveredCart };
        case SET_CART_LOADING:
            return { ...state, isLoading: action.payload.isLoading };
        case UPDATE_CART_PARTIAL:
            return {
                ...state,
                cart: state.cart
                    ? {
                          ...state.cart,
                          ...action.payload.updates,
                      }
                    : null,
            };
        case RESERVE_CART_START:
            return {
                ...state,
                isLoading: true,
                reservationError: null,
            };
        case RESERVE_CART_SUCCESS:
            return {
                ...state,
                cart: action.payload.cart,
                isLoading: false,
                reservationError: null,
            };
        case RESERVE_CART_FAILURE:
            return {
                ...state,
                isLoading: false,
                reservationError: action.payload.error,
            };
        default:
            return state;
    }
};

export default reducer;
